import { call, put, takeLatest } from 'redux-saga/effects';
import {
  ENTITY_FETCH_LIST_REQUEST,
  ENTITY_FETCH_LIST_SUCCESS,
  ENTITY_FETCH_LIST_FAILURE,
} from './entity.constants';
import { apiStatusCodes } from 'utils/API/apiStatusCodes';
import { API_ENTITY_LIST1 } from 'utils/API/apiUrls';
import { POST } from 'utils/fetchWrappers';
import { EntityListRequest } from './dto/EntityListRequest.dto';

/**
 * Saga to fetch entity list based on entity type and optional filters.
 * This handles success and failure responses gracefully.
 */

function* fetchEntityListSaga(actions) {
  try {
    const { payload, entityData } = actions;

    // Build the API request payload
    const request = new EntityListRequest(payload, entityData);
    const response = yield call(POST, API_ENTITY_LIST1, request);
    
    if (response?.data?.statusCode === apiStatusCodes.SUCCESS2) {
        const entityList = response.data?.entities || [];
        // Dispatch success action with fetched entity list (even if it's empty)
        yield put({ type: ENTITY_FETCH_LIST_SUCCESS, payload: entityList });
    } else {
        const errorMsg = response?.data?.errorMessage || 'Unexpected API error';
        // Handle case where API call was not successful
        yield put({ type: ENTITY_FETCH_LIST_FAILURE, payload: errorMsg });
    }
  } catch (error) {
    let errorPayload = 'Something went wrong while fetching entity data.';

    if (error?.response?.data) {
      errorPayload =
        error.response.data.errorMessage ||
        error.response.data.message ||
        errorPayload;
    } else if (error?.message) {
      errorPayload = error.message;
    }

    console.error('Entity Fetch Error:', error);

    yield put({ type: ENTITY_FETCH_LIST_FAILURE, payload: errorPayload });
  }
}

/**
 * Watcher saga that listens to ENTITY_FETCH_LIST_REQUEST
 * and triggers the worker saga to handle the side effect.
 */

export default function* entitySagas() {
  yield takeLatest(ENTITY_FETCH_LIST_REQUEST, fetchEntityListSaga);
}
